
window.init_vendor_map = function()
{
    if(gon.lng != undefined){
        try {
            var pos = { lat: parseFloat(gon.lat[0]), lng: parseFloat(gon.lng[0]) };
            var bounds = new google.maps.LatLngBounds();
            const map = new google.maps.Map(document.getElementById("googlemap"), {
                zoom: 17,
                fullscreenControl : false,
                streetViewControl : false,
                mapTypeControl: false,
                center: pos
            });

            for(var i=0;i<gon.lat.length;i++){

                var pos = { lat: parseFloat(gon.lat[i]), lng: parseFloat(gon.lng[i]) };
                // The marker, positioned at Uluru
                var marker = new google.maps.Marker({
                    position: pos,
                    map: map,
                    url: gon.urls[i],
                    icon: gon.vendor_logos[i]
                });

                google.maps.event.addListener(marker,'click', (function(marker){
                    return function() {
                        window.location.href = marker.url;
                    };
                })(marker));

                bounds.extend(marker.position);
            }

            map.fitBounds(bounds);
        }catch (error) {
            setTimeout(function(){init_vendor_map();},500)
        }
    }
}

init_vendor_map();

window.addEventListener("mapsLoaded", function(event)
{
    init_vendor_map();
});
const titleElement = document.querySelector('title');
if (titleElement) {
  document.title = gon.meta_title_for_search;
}
